import request from 'admin-ng/util/request-promise';
import {PLANS} from '.';

export const all = params => request(PLANS, 'get', params);
export const one = id => request(`${PLANS}${id}`, 'get');
export const update = (id, params) => request(`${PLANS}${id}`, 'put', params);
export const create = params => request(PLANS, 'post', params);
export const del = id => request(`${PLANS}${id}`, 'del');
